import  AmenitiesBroll  from "./AmenitiesBroll";

export default AmenitiesBroll